module.exports = __webpack_public_path__ + "static/media/flashSuccess.c010806a.svg";